import { usePage } from "@inertiajs/react"
import AppLayout from "@/components/AppLayout"
import PageTitle from "@/components/PageTitle"
import ProfileForm from "./components/ProfileForm"
import PasswordForm from "./components/PasswordForm"

interface PageProps {
  user?: { name: string | null; email: string; slack_handle: string | null; avatar_url: string | null; avatar_source: string | null }
  [key: string]: unknown
}

export default function Show() {
  const { props } = usePage<PageProps>()
  const user = props.user
  if (!user) return null

  return (
    <AppLayout header={<PageTitle title="Settings" subtitle="Your profile and account" />}>
      <div className="flex flex-col gap-6 max-w-2xl">
        <ProfileForm user={user} />
        <PasswordForm />
      </div>
    </AppLayout>
  )
}
